import DailyTopChartCharacter from './DailyTopChartCharacter'
import withDailyTopChartCharacter from './withDailyTopChartCharacter'

const ConnectedDailyTopChartCharacter = withDailyTopChartCharacter(
  DailyTopChartCharacter
)
export { ConnectedDailyTopChartCharacter as DailyTopChartCharacter }
